var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _path9, _path0, _path1, _path10, _path11, _path12, _path13, _path14;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgMultiColorDownload = function SvgMultiColorDownload(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24"
  }, props), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 14.957,
    height: 15.043,
    x: 4.521,
    y: 4.523,
    fill: "#130E3A",
    rx: 4.413
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.5 17.367a.75.75 0 0 1-.75-.75v-1c0-.413.337-.75.75-.75h1c.413 0 .75.337.75.75v1c0 .413-.337.75-.75.75z",
    opacity: 0.05
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M11.5 17.162a.54.54 0 0 1-.541-.542v-1c0-.299.243-.542.542-.542h1c.298 0 .541.243.541.542v1a.54.54 0 0 1-.541.541z",
    opacity: 0.07
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#F71278",
    d: "M12.5 16.952h-1a.333.333 0 0 1-.334-.334v-1c0-.184.15-.333.333-.333h1c.184 0 .334.15.334.333v1c0 .185-.15.334-.334.334"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14 17.367a.75.75 0 0 1-.75-.75v-1c0-.413.337-.75.75-.75h1c.413 0 .75.337.75.75v1c0 .413-.337.75-.75.75z",
    opacity: 0.05
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M14 17.162a.54.54 0 0 1-.541-.542v-1c0-.299.243-.542.542-.542h1c.298 0 .541.243.541.542v1a.54.54 0 0 1-.541.541z",
    opacity: 0.07
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#CBD0FA",
    d: "M15 16.952h-1a.333.333 0 0 1-.334-.334v-1c0-.184.15-.333.333-.333h1c.184 0 .334.15.334.333v1c0 .185-.15.334-.334.334"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 17.367a.75.75 0 0 1-.75-.75v-1c0-.413.337-.75.75-.75h1c.413 0 .75.337.75.75v1c0 .413-.337.75-.75.75z",
    opacity: 0.05
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M16.5 17.162a.54.54 0 0 1-.541-.542v-1c0-.299.243-.542.542-.542h1c.298 0 .541.243.541.542v1a.54.54 0 0 1-.541.541z",
    opacity: 0.07
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    fill: "#B1B9FE",
    d: "M17.5 16.952h-1a.333.333 0 0 1-.334-.334v-1c0-.184.15-.333.333-.333h1c.184 0 .334.15.334.333v1c0 .185-.15.334-.334.334"
  })), _path0 || (_path0 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.5 17.367a.75.75 0 0 1-.75-.75v-1c0-.413.337-.75.75-.75h1c.413 0 .75.337.75.75v1c0 .413-.337.75-.75.75z",
    opacity: 0.05
  })), _path1 || (_path1 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M6.5 17.162a.54.54 0 0 1-.541-.542v-1c0-.299.243-.542.542-.542h1c.298 0 .541.243.541.542v1a.54.54 0 0 1-.541.541z",
    opacity: 0.07
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M7.5 16.952h-1a.333.333 0 0 1-.334-.334v-1c0-.184.15-.333.333-.333h1c.185 0 .334.15.334.333v1c0 .185-.15.334-.334.334"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 17.367a.75.75 0 0 1-.75-.75v-1c0-.413.337-.75.75-.75h1c.413 0 .75.337.75.75v1c0 .413-.337.75-.75.75z",
    opacity: 0.05
  })), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    fill: "#000",
    d: "M9 17.162a.54.54 0 0 1-.541-.542v-1c0-.299.243-.542.542-.542h1c.298 0 .541.243.541.542v1a.54.54 0 0 1-.541.541z",
    opacity: 0.07
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M10 16.952H9a.333.333 0 0 1-.334-.334v-1c0-.184.15-.333.333-.333h1c.184 0 .334.15.334.333v1c0 .185-.15.334-.334.334"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    fill: "#FAFAFB",
    d: "M14.995 9.971h-1.746v-6.25a.417.417 0 0 0-.417-.416h-1.666a.417.417 0 0 0-.417.416v6.25H9.003c-.3 0-.45.363-.238.575l2.792 2.792c.245.244.64.244.884 0l2.792-2.792a.337.337 0 0 0-.238-.575"
  })));
};
export { SvgMultiColorDownload as ReactComponent };